module.exports = __webpack_public_path__ + "svg/chevron-icon.60ec73b8d51e23ba0922c8347746f556.svg";